import { HttpMethods, APIContexts } from 'enums';
import { apiRequestHandler, apiHost } from '.';

const apiContext = `${APIContexts.TITLE}/`;

export const GetPrioritisationListAPI = ({
  queryParams,
  onSuccess,
  ...rest
}) => {
  const api = 'GetPrioritisationList';
  const endpoint = `${apiHost}${apiContext}${api}?channelId=${queryParams.channelId}`;
  apiRequestHandler({
    endpoint,
    method: HttpMethods.GET,
    onSuccess: (res) => onSuccess(res),
    ...rest,
  });
};

export const GetProgrammeTitlesListAPI = ({
  queryParams = null,
  onSuccess,
  ...rest
}) => {
  const api = 'GetProgrammeTitlesList';
  const query =
    queryParams !== null ? `?channelId=${queryParams.channelId}` : '';
  const endpoint = `${apiHost}${apiContext}${api}${query}`;
  apiRequestHandler({
    endpoint,
    method: HttpMethods.GET,
    onSuccess: (res) => onSuccess(res),
    ...rest,
  });
};

export const GetTitleDetailsAPI = ({ queryParams, onSuccess, ...rest }) => {
  const api = 'GetTitleDetails';
  const endpoint = `${apiHost}${apiContext}${api}?titleId=${queryParams.id}&channelId=${queryParams.channelId}`;
  apiRequestHandler({
    endpoint,
    method: HttpMethods.GET,
    onSuccess: (res) => onSuccess(res),
    ...rest,
  });
};
